import { render, staticRenderFns } from "./UnitesTab.vue?vue&type=template&id=67fd813e&scoped=true&"
import script from "./UnitesTab.vue?vue&type=script&lang=js&"
export * from "./UnitesTab.vue?vue&type=script&lang=js&"
import style0 from "./UnitesTab.vue?vue&type=style&index=0&id=67fd813e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fd813e",
  null
  
)

export default component.exports